import React from "react";
import UaeMofaHead from "../../UaeAttestation/UaeMofa/UaeMofaHead";
import "./../../UaeAttestation/UaeMofa/UaeMofa.css";
import KuwaitMofaMain from "./KuwaitMofaMain";

const KuwaitMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <KuwaitMofaMain />
    </div>
  );
};

export default KuwaitMofa;
